import { useState } from 'react';

export type DownloadState = {
  progress: number;
  loading: boolean;
  failed: boolean;
};

export const INITIALDOWNLOADSTATE: DownloadState = {
  progress: 0,
  loading: false,
  failed: false,
};

export const TESTINGDOWNLOADSTATE: DownloadState = {
  progress: 50,
  loading: true,
  failed: false,
};

const useDownloadState = () => {
  const [downloads, setDownloads] = useState<Record<string, DownloadState>>({});

  const patchDownload = (id: string, patch: Partial<DownloadState>) =>
    setDownloads((prev) => ({
      ...prev,
      [id]: { ...INITIALDOWNLOADSTATE, ...prev[id], ...patch },
    }));

  const startDownload = (id: string) =>
    patchDownload(id, { loading: true, failed: false, progress: 1 });

  const progressDownload = (id: string, pct: number) =>
    patchDownload(id, { progress: pct, loading: pct < 100 });

  const successDownload = (id: string) =>
    patchDownload(id, { progress: 100, loading: false, failed: false });

  const failDowload = (id: string) => patchDownload(id, { loading: false, failed: true });

  const resetDownload = (id: string) => patchDownload(id, INITIALDOWNLOADSTATE);

  return {
    downloads,
    startDownload,
    progressDownload,
    successDownload,
    failDowload,
    resetDownload,
    INITIALDOWNLOADSTATE,
    TESTINGDOWNLOADSTATE,
  };
};

export default useDownloadState;
